import React, { useEffect, useState } from 'react';
import '../styles/payment-confirm.css';
import Text from 'ui/Text';
import Button from 'ui/Button';
import { formatDenmarkCurrency } from 'utils/UiHelper';
import usePurchaseConfirm from 'features/SpilKlub/state/usePurchaseConfirm';
import ViewSpinner from 'components/ViewSpinner';
import successIcon from 'images/success_icon.svg';
import { NotificationManager } from 'react-notifications';
import dropdownModal from 'features/SpilKlub/HOCs/dropdownModal';
import AddSharesButton from 'features/SpilKlub/components/AddSharesButton';

const PaymentConfirm = ({
    isOpen = false,
    groupName = '',
    numberOfShares = '2',
    // winPrice = 200,
    totalPrice = 0,
    onClose = () => {},
    onSuccess = () => {},
    pool,
    balance,
    selectShares,
    setSelectShares,
    uiActions,
}) => {
    const { status, save, reset, error, isError } = usePurchaseConfirm({
        pool,
    });
    const [sharesButton, setSharesButton] = useState(false);
    const poolId = pool?.poolId;

    const handleModalOpen = () => {
        if (totalPrice > balance) {
            uiActions.showModal('LOW_BALANCE');
            onClose();
        }
    };

    useEffect(
        () => {
            if (!isOpen) {
                reset();
                setSharesButton(false);
                onClose();
            }
        },
        [isOpen]
    );

    useEffect(
        () => {
            if (status === 'success') {
                setTimeout(() => {
                    onSuccess();
                }, 1000);
            }
        },
        [status]
    );

    return (
        <>
            <hr size={1} color={'#DADDE4'} />
            <div className={'sk-payment-confirm-shares'}>
                <div
                    className={`sk-number-of-shares ${
                        sharesButton ? 'shares-button' : ''
                    }`}
                    onClick={() => {
                        sharesButton && setSharesButton(false);
                    }}
                >
                    {sharesButton ? (
                        <Text color={'#333'} bold size={'x15'} align={'center'}>
                            {numberOfShares}
                        </Text>
                    ) : (
                        <AddSharesButton
                            selectShares={selectShares}
                            onChange={setSelectShares}
                            pool={pool}
                            onSharesClick={() => setSharesButton(false)}
                            setSharesButton={setSharesButton}
                        />
                    )}
                </div>
                <div>
                    <Text
                        size={'x15'}
                        color={'#333'}
                        margin={'0 0 5px'}
                        padding={'0'}
                    >
                        Andele - {groupName}
                    </Text>
                    <Text
                        size={'x15'}
                        bold
                        color={'#18AA1B'}
                        margin={'0'}
                        padding={'0'}
                    >
                        Samlet pris: {formatDenmarkCurrency(totalPrice)} kr.
                    </Text>
                </div>
            </div>
            <hr size={1} color={'#DADDE4'} />
            <Button
                active={status !== 'success'}
                green={status === 'success'}
                width={'calc(100% - 18px)'}
                margin={'27px auto 0'}
                justify={
                    status !== 'loading' && status !== 'success'
                        ? 'space-between'
                        : 'center'
                }
                padding={'15px 40px'}
                fontSize={'16px'}
                onClick={() => {
                    handleModalOpen();
                    if (status !== 'success') {
                        save({ poolId, numberOfShares });
                    }
                }}
            >
                {status === 'loading' ? (
                    <ViewSpinner
                        style={{
                            padding: 0,
                            fontSize: 9,
                        }}
                    />
                ) : status === 'success' ? (
                    <>
                        <span style={{ marginRight: 7 }}>Andele købt</span>
                        <img src={successIcon} alt="success" />
                    </>
                ) : (
                    <>
                        <span>Køb andele</span>
                        <span>{formatDenmarkCurrency(totalPrice)} kr.</span>
                    </>
                )}
            </Button>
        </>
    );
};

export default dropdownModal(PaymentConfirm);
